var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconmapDoctor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.56,
    height: 33.84,
    viewBox: "0 0 34.56 33.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_map-doctor",
    "data-name": "Icon map-doctor",
    d: "M30.905,9.36H27.36V5.6A4.829,4.829,0,0,0,22.54.72H13.46A4.828,4.828,0,0,0,8.64,5.6V9.36H5.094A4.294,4.294,0,0,0,.72,13.635V30.2a4.367,4.367,0,0,0,4.374,4.36H30.905A4.368,4.368,0,0,0,35.28,30.2V13.635A4.3,4.3,0,0,0,30.905,9.36ZM11.52,5.6a2.079,2.079,0,0,1,1.94-2h9.08a2.081,2.081,0,0,1,1.94,2V9.36H11.52Zm14.4,19.6H20.88v5.04H15.12V25.2H10.08V19.44h5.04V14.4h5.76v5.04h5.04V25.2Z",
    transform: "translate(-0.72 -0.72)",
    fill: "#0c8de0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconmapDoctor);
export default __webpack_public_path__ + "static/media/Icon map-doctor.12b692743fac717b5a4908776c19dab3.svg";
export { ForwardRef as ReactComponent };